/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React from "react";
import "./Loader.css";
import loader from '../../../../public/gif/loader.gif'

interface LoaderProps {
  src?: string;       // Path to GIF (default: /loader.gif in public)
  altText?: string;   // Accessibility text
  size?: number;      // Size in px
  visible?: boolean;  // Show/Hide
}

const Loader: React.FC<LoaderProps> = ({
  
  altText = "Loading…",
  size = 80,
  visible = true,
}) => {
  if (!visible) return null;

  return (
    <div className="loader-content-area">
      <img src={loader} alt={altText} width={size} height={size} />
    </div>
  );
};

export default Loader;
